<template>
  <van-dialog class="Vue2verify" v-model="vueVerify" :show-confirm-button="false">
    <div class="toptips">
      <div class="lftips">
        <p >安全验证</p>
        <p class="tipsword">请在输入框内填写正确的字符</p>
      </div>
      <div class="rgtips">
        <van-icon @click="close()" class="closeicon" name="close" />
      </div>
    </div>
    <Verify width="96%" ref="vueVerify" :type="typenum" @success="success" @error="error"></Verify>
    <div class="succtip" v-if="endStatus">
      <span :class="succfail?'succ':'fail'">{{succfail?'验证通过':'验证失败'}}</span>
    </div>
  </van-dialog>
</template>

<script>
  import Verify from 'vue2-verify'
  import {mapState,mapMutations} from "vuex"
  export default {
    components:{
      Verify
    },
    data(){
      return{
        endStatus:false,
        succfail:false,
        typenum:1
      }
    },
    methods:{
      ...mapMutations('showData',['changeTFalse']),
      success(reFn){
        this.endStatus=true
        this.succfail=true
        //传递成功值
        this.changeTFalse([{name:'vueVerifyStatus',value:true}])
        //关闭
        setTimeout(() => {
          this.changeTFalse([{name:'vueVerify',value:false}])
          this.endStatus=false
        }, 300);
        setTimeout(() => {
          this.typenum=Math.random()*10>5?1:2
          reFn.refresh()
        }, 500);
      },
      error(){
        this.endStatus=true
        this.succfail=false
      },
      close(){
        this.changeTFalse([{name:'vueVerify',value:false}])
        this.endStatus=false
        setTimeout(()=>{
          this.typenum=Math.random()*10>5?1:2
          this.$refs.vueVerify.refresh()
        },500)
      }
    },
    computed:{
      ...mapState('showData',['vueVerify']),
      vueVerify:{
        get () {
          return this.$store.state.showData.vueVerify
        },
        set (value) {
          this.changeTFalse([{name:'vueVerify',value:value}])
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.Vue2verify{
  width: 90%;
  display: flex;
  justify-content: center;
  background-color: rgb(255, 255, 255)!important;
  border-radius: .1333rem !important;
  padding: .5333rem .2667rem;
  box-sizing: border-box;
  height: 8rem;
  /deep/.van-dialog__content{
    width: 100%;
  }
  .toptips{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: .2667rem;
    .lftips{
      font-size: .3733rem;
      line-height: .6667rem;
      color: rgb(153, 153, 153);
      .tipsword{
        font-size: .48rem;
        color: #000;
        line-height: 1.5em;
        font-weight: 500;
      }
    }
    .rgtips{
      width: .8rem;
      align-self: start;
      .closeicon{
        font-size: .64rem;
        color: #999;
      }
    }
  }
  /deep/.van-dialog__content{
    position: relative;
    // 输入字符
    >div:nth-child(2){
      .cerify-code-panel{
        .verify-code{
          margin-bottom: .5333rem;
        }
        .verify-change-area{
          margin-left: 1.0667rem;
        }
      }
      >div:nth-child(2){
        width: 60%!important;
        height: .96rem !important;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1.3333rem auto 0;
        >button{
          margin-top: 0 !important;
          background-color: rgb(26, 121, 255) !important;
          box-shadow: rgba(26, 121, 255, 0.5) 0px 0px 5.04464px 0.504464px;
          border-radius: .5333rem;
        }
      }
    }
    .succtip{
      position: absolute;
      bottom: 1.3333rem;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      font-size: .32rem;
      span.succ{
        color: #00b465;
      }
      span.fail{
        color: #d10d00;
      }
    }
  }
}
</style>